import { useState } from "react";
import { getAPIFromDomain } from "../../../lib/api";
import UrlBuilder from "../../../lib/UrlBuilder";
import { APIResponse } from "@secondcloset/api-utils";

// interface
import { Role } from "../../../interfaces/common/role";

const useRolesIndex = () => {
  const [data, setData] = useState<Role[]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const api = getAPIFromDomain("accounts");

  const fetchRolesIndex = (query: any) => {
    setLoading(true);
    setError("");
    const urlBuilder = new UrlBuilder("/roles");
    const url = urlBuilder.applyQueryStringFromObject(query);

    return api
      .get(url)
      .then((res: APIResponse): Role[] => {
        const roles = res.data;
        setData(roles);
        setLoading(false);
        return roles;
      })
      .catch((error: any) => {
        setLoading(false);
        setError(error);
        return false;
      });
  };

  const rolesIndex = { data, loading, error };

  return { fetchRolesIndex, rolesIndex };
};

const useRoleDetails = () => {
  const [data, setData] = useState<Role>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const api = getAPIFromDomain("accounts");

  const fetchRoleDetails = (roleID: string) => {
    setLoading(true);
    setError("");

    const url = `/roles/${roleID}`;

    return api
      .get(url)
      .then((res: APIResponse) => {
        const role: Role = res.data;
        setData(role);
        setLoading(false);
        return role;
      })
      .catch((error: any) => {
        setLoading(false);
        setError(error);
        return false;
      });
  };

  const createRole = (body: any) => {
    const url = `/roles`;
    setLoading(true);
    setError("");

    return api
      .post(url, body)
      .then((res: APIResponse) => {
        const role = res.data;
        setData(role);
        setLoading(false);
        return role;
      })
      .catch((error: any) => {
        setLoading(false);
        setError(error);
        return false;
      });
  };

  const updateRole = (roleID: string, body: any) => {
    const url = `/roles/${roleID}`;
    setLoading(true);
    setError("");

    return api
      .put(url, body)
      .then((res: APIResponse) => {
        const role = res.data;
        setData(role);
        setLoading(false);
        return role;
      })
      .catch((error: any) => {
        setLoading(false);
        setError(error);
        return false;
      });
  };

  const roleDetails = { data, loading, error };

  return { fetchRoleDetails, roleDetails, createRole, updateRole };
};

export { useRolesIndex, useRoleDetails };
